<template>
  <div
    class="main"
    data-app="true"
  >
    <JumbotronView :message="message" />
    <v-app class="app-style mx-auto">
      <v-row
        no-gutters
      >
        <v-col
          cols="12"
          md="8"
          offset-md="2"
        >
          <v-progress-linear
            :value="progress"
            class="progress-bar"
            color= "#007769"
            background-color= "#D8D8D8"
          ></v-progress-linear>
          <address-amount-card  v-if="applyCard == 'address-amount-card'" />
          <account-creation-card  v-if="applyCard == 'account-creation-card'" />
        </v-col>
      </v-row>
    </v-app>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import JumbotronView from '../JumbotronView.vue';
import AddressAmountCard from './AddressAmountCard.vue';
import AccountCreationCard from './AccountCreationCard.vue';

export default {
  name: 'ApplicationPage',
  metaInfo: {
    title: 'Continue Your Application',
    meta: [
      {
        name: 'robots',
        content: 'noindex'
      }
    ]
  },
  components: {
    JumbotronView,
    'address-amount-card': AddressAmountCard,
    'account-creation-card': AccountCreationCard,
  },
  data() {
    return {
      message: "You're pre-qualified.",
    };
  },
  computed: {
    ...mapGetters([
      'applyCard',
    ]),
    progress() {
      return this.applyCard == 'address-amount-card' ? 20 : 40;
    }
  },
};
</script>

<style scoped lang="scss">
  #app.app-style.v-application {
    font-family: 'Open Sans';
    background-color: #F2F2F2;
    ::v-deep .v-application--wrap {
      min-height: auto;
    }

    @media (max-width: 768px) {
      padding: 0;
    }

    @media (min-width: 768px) {
      padding: 30;
    }
  }

  .progress-bar {
    height: 10px !important;
    border: 1px solid #A9A9A9;
    
    @media (min-width: 768px) {
      margin-top: 15px;
      margin-bottom: 30px;
    }
  }
</style>
